import { api } from '@unboared/react';

/**
 * Returns the raw Socket.IO client instance backing the Unboared API, or
 * `undefined` if the API hasn't been initialized yet.
 *
 * The `wss` property is not part of the public `@unboared/lib` typings, so it's
 * accessed through an `any` cast. Centralizing it here keeps that cast in one
 * place instead of duplicating it across hooks (useKeepAlive,
 * useConnectionStatus, useSentrySocketBreadcrumbs, ...).
 */
export function getRawSocket(): any | undefined {
    return (api() as any)?.wss;
}
